import { Prisma } from '@prisma/client';
import { StockProjectNotFoundError } from './stock.errors';

export async function lockStockProject(tx: Prisma.TransactionClient, projectId: number): Promise<void> {
  await lockStockProjects(tx, [projectId]);
}

export async function lockStockProjects(tx: Prisma.TransactionClient, projectIds: number[]): Promise<void> {
  const uniqueProjectIds = [...new Set(projectIds)].sort((a, b) => a - b);
  if (uniqueProjectIds.length === 0) return;

  // Take the exclusive lock first. Running INSERT IGNORE first makes each transaction hold a shared lock
  // on the existing row, and two of them then block each other's upgrade to exclusive (deadlock) rather
  // than queuing.
  let rows = await selectLockRows(tx, uniqueProjectIds);

  if (rows.length !== uniqueProjectIds.length) {
    await tx.$executeRaw`
      INSERT IGNORE INTO StockProjectLock (projectId)
      SELECT id FROM Project
      WHERE id IN (${Prisma.join(uniqueProjectIds)})
    `;
    rows = await selectLockRows(tx, uniqueProjectIds);
  }

  if (rows.length !== uniqueProjectIds.length) {
    const lockedProjectIds = new Set(rows.map(row => row.projectId));
    const missingProjectId =
      uniqueProjectIds.find(projectId => !lockedProjectIds.has(projectId)) ?? uniqueProjectIds[0];
    throw new StockProjectNotFoundError(missingProjectId);
  }
}

function selectLockRows(tx: Prisma.TransactionClient, projectIds: number[]): Promise<{ projectId: number }[]> {
  return tx.$queryRaw<{ projectId: number }[]>`
    SELECT projectId FROM StockProjectLock
    WHERE projectId IN (${Prisma.join(projectIds)})
    ORDER BY projectId
    FOR UPDATE
  `;
}
